import React from 'react';
import './index.css';

export function PublicPage({ children, className = '' }) {
  return <main className={`agist-public-page ${className}`.trim()}>{children}</main>;
}

export function PublicHero({ eyebrow, title, lead, actions = null, aside = null, className = '' }) {
  return (
    <section className={`agist-hero ${className}`.trim()}>
      <div className="agist-hero-image" />
      <div className="agist-hero-grid" />
      <div className="agist-hero-content">
        {eyebrow && <p className="agist-eyebrow">{eyebrow}</p>}
        <h1>{title}</h1>
        {lead && <p className="agist-hero-lead">{lead}</p>}
        {actions && <div className="agist-hero-actions">{actions}</div>}
      </div>
      {aside && <div className="agist-hero-note">{aside}</div>}
    </section>
  );
}

export function PublicSection({ eyebrow, title, children, className = '' }) {
  return (
    <section className={`agist-section ${className}`.trim()}>
      {(eyebrow || title) && (
        <div className="agist-section-heading">
          {eyebrow && <p className="agist-eyebrow">{eyebrow}</p>}
          {title && <h2>{title}</h2>}
        </div>
      )}
      {children}
    </section>
  );
}

export function PublicContentPage({ eyebrow, title, lead, image, children, className = '' }) {
  return (
    <PublicPage className={className}>
      <section className="agist-page-hero">
        <div className="agist-page-hero-copy">
          {eyebrow && <p className="agist-eyebrow">{eyebrow}</p>}
          <h1>{title}</h1>
          {lead && <p>{lead}</p>}
        </div>
        {image && (
          <div className="agist-page-hero-image">
            <img src={image} alt="" />
          </div>
        )}
      </section>
      <section className="agist-content-panel">{children}</section>
    </PublicPage>
  );
}
